<mat-card class="ui-wrapper">
        <div class="row">
            <div class="col-md-6 p-2">
                <mat-card>

                    <div class="row">
                        <div class="col-md-12">
                            <mat-card-title>Stock difference</mat-card-title>
                        </div>                      
                    </div>

                    <form [formGroup]="diffDateRangeForm">

                        <mat-form-field class="me-2" appearance="outline">
                            <mat-label>Enter a date range</mat-label>
                            <mat-date-range-input [rangePicker]="diffPicker">
                                <input formControlName="start" matStartDate placeholder="Start date">
                                <input formControlName="end" matEndDate placeholder="End date">
                            </mat-date-range-input>
                            <mat-hint>YYYY/MM/DD – YYYY/MM/DD</mat-hint>
                            <mat-datepicker-toggle matSuffix [for]="diffPicker"></mat-datepicker-toggle>
                            <mat-date-range-picker #diffPicker></mat-date-range-picker>
                        </mat-form-field>
                    </form>

                    <mat-card-actions>
                        <div class="text-start">
                            <mat-form-field class="me-2" appearance="outline">
                                <mat-label>Report type</mat-label>
                                <mat-select [formControl]="downloadDiffReportControl">
                                    <mat-option value="csv">CSV</mat-option>
                                    <mat-option value="excel">Excel</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <button [disabled]="downloadDiffReportControl.invalid || diffDateRangeForm.invalid" class="me-2" mat-stroked-button
                                (click)="generateAndDownloadDiff()">
                                <mat-icon>file_download</mat-icon> Download
                            </button>
                        </div>
                    </mat-card-actions>
                </mat-card>
            </div>
            <div class="col-md-6 p-2">
                <mat-card>

                    <div class="row">
                        <div class="col-md-12">
                            <mat-card-title>Scanned stock</mat-card-title>
                        </div>                      
                    </div>

                    <form [formGroup]="scannedDateRangeForm">

                        <mat-form-field class="me-2" appearance="outline">
                            <mat-label>Enter a date range</mat-label>
                            <mat-date-range-input [rangePicker]="scannedPicker">
                                <input formControlName="start" matStartDate placeholder="Start date">
                                <input formControlName="end" matEndDate placeholder="End date">
                            </mat-date-range-input>
                            <mat-hint>YYYY/MM/DD – YYYY/MM/DD</mat-hint>
                            <mat-datepicker-toggle matSuffix [for]="scannedPicker"></mat-datepicker-toggle>
                            <mat-date-range-picker #scannedPicker></mat-date-range-picker>
                        </mat-form-field>
                    </form>

                    <mat-card-actions>
                        <div class="text-start">
                            <mat-form-field class="me-2" appearance="outline">
                                <mat-label>Report type</mat-label>
                                <mat-select [formControl]="downloadScannedReportControl">
                                    <mat-option value="csv">CSV</mat-option>
                                    <mat-option value="excel">Excel</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <button [disabled]="downloadScannedReportControl.invalid || downloadScannedReportControl.invalid" class="me-2" mat-stroked-button
                                (click)="generateAndDownloadScanned()">
                                <mat-icon>file_download</mat-icon> Download
                            </button>
                        </div>
                    </mat-card-actions>
                </mat-card>
            </div>

        </div>
</mat-card>